import React from 'react';
import { FormattedDate } from 'react-intl';

import { withLocaleContext } from '../../../locales/locale-context.js';
import { prefixPathWithLocale } from '../../../locales/locale-paths.js';
import { NavLink as Link } from 'react-router-dom';

import noImage from '../../../assets/images/news/no-photo.png';

import './news-card.scss';

const Card = ({
	title,
	image,
	date,
	extraClasses,
	slug,
	localeContext: { locale },
}) => (
	<div className={`news-card ${extraClasses}`}>
		<Link to={prefixPathWithLocale(`/news/${slug}`, locale)}>
			<div className="image">
				{image && image.length !== 0 ? (
					<img
						src={`${process.env.REACT_APP_API_ENDPOINT + image.path}`}
						alt={title}
					/>
				) : (
					<img src={noImage} alt={title} />
				)}
			</div>
			<div className="content">
				<div className="info">
					<h6>{title}</h6>
					<FormattedDate
						value={date}
						month="short"
						day="numeric"
						year="numeric"
					/>
				</div>
			</div>
		</Link>
	</div>
);

export default withLocaleContext(Card);
